import { render, staticRenderFns } from "./personal-center.vue?vue&type=template&id=61b6eb44&scoped=true&"
import script from "./personal-center.vue?vue&type=script&lang=js&"
export * from "./personal-center.vue?vue&type=script&lang=js&"
import style0 from "./personal-center.vue?vue&type=style&index=0&id=61b6eb44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b6eb44",
  null
  
)

export default component.exports